import * as React from 'react';
const SvgV = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M12 22c-.432 0-.822-.259-.988-.657l-7.5-17.855a1.07 1.07 0 1 1 1.976-.83l6.511 15.503 6.513-15.503a1.07 1.07 0 1 1 1.975.83l-7.499 17.855A1.072 1.072 0 0 1 12 22Z", fill: "currentColor" })));
export default SvgV;
